import { apiInstance } from '../config/apiInstance';

export const deleteData = async(url:string): Promise<any> => {
    const response = await apiInstance.delete( url );
    return response.data;
}